import * as ActionTypes from "../Actions/ActionTypes";
import { updateObject } from "../Utility";
import * as LocalStorageKeys from "../../HOCs/Constants/LocalStorageKeys";

const initialState = {
  ticketPairInfo: [],
  numberOfBets: 0,
  numberOfBetsFormatted: 0,
  totalOdds: 0,
  betAmount: 0,
  ticketTypeID: 2, //po default combo
  systemCombinations: [],
  currentlyEditedCombinationID: 0
};

const reducer = (state = initialState, action) => {
  let index = 0;
  let pairInfos = [];
  let updatedObject = {};
  let systemInfoes = [];

  switch (action.type) {
    case ActionTypes.TICKET_ADD_PAIR:
      pairInfos = [...state.ticketPairInfo];

      //vidi ako vec ima
      index = pairInfos.findIndex(x => x.matchID === action.pairInfo.matchID);

      if (index !== -1) {
        pairInfos[index] = action.pairInfo;
      } else {
        pairInfos.push(action.pairInfo);
      }

      //podesi im oznake
      pairInfos = processSystemLegends(pairInfos, state.ticketTypeID);
      systemInfoes = generateSystemCombinationsInfo(
        pairInfos,
        state.ticketTypeID
      );

      //updateaj systeminfo s pairinfos
      systemInfoes = updatePossibleWinPerCombination(pairInfos, systemInfoes);

      updatedObject = updateObject(state, {
        ticketPairInfo: pairInfos,
        totalOdds: getTotalOdds(pairInfos),
        numberOfBets: getNumberOfBets(pairInfos),
        numberOfBetsFormatted: getFormattedNumberOfBets(
          pairInfos,
          state.ticketTypeID
        ),
        systemCombinations: systemInfoes
      });

      //pisi ga u local storage
      console.log("Saving items in local storage...");
      localStorage.setItem(
        LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS,
        JSON.stringify(updatedObject)
      );

      return updatedObject;
    case ActionTypes.TICKET_REMOVE_PAIR:
      pairInfos = [...state.ticketPairInfo];
      index = pairInfos.findIndex(x => x.matchID === action.matchID);
      if (index !== -1) {
        pairInfos.splice(index, 1);
      }

      //podesi im oznake
      pairInfos = processSystemLegends(pairInfos, state.ticketTypeID);
      systemInfoes = generateSystemCombinationsInfo(
        pairInfos,
        state.ticketTypeID
      );

      //updateaj systeminfo s pairinfos
      systemInfoes = updatePossibleWinPerCombination(pairInfos, systemInfoes);

      updatedObject = updateObject(state, {
        ticketPairInfo: pairInfos,
        totalOdds: getTotalOdds(pairInfos),
        numberOfBets: getNumberOfBets(pairInfos),
        numberOfBetsFormatted: getFormattedNumberOfBets(
          pairInfos,
          state.ticketTypeID
        ),
        systemCombinations: systemInfoes
      });

      //pisi ga u local storage
      console.log("Saving items in local storage...");
      localStorage.setItem(
        LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS,
        JSON.stringify(updatedObject)
      );

      return updatedObject;
    case ActionTypes.TICKET_TOGGLE_PAIR_FIX_STATE:
      pairInfos = [...state.ticketPairInfo];
      index = pairInfos.findIndex(x => x.matchID === action.matchID);
      if (index !== -1) {
        pairInfos[index].isFix = !pairInfos[index].isFix;
      }

      //podesi im oznake
      pairInfos = processSystemLegends(pairInfos, state.ticketTypeID);
      systemInfoes = generateSystemCombinationsInfo(
        pairInfos,
        state.ticketTypeID
      );

      //updateaj systeminfo s pairinfos
      systemInfoes = updatePossibleWinPerCombination(pairInfos, systemInfoes);

      updatedObject = updateObject(state, {
        ticketPairInfo: pairInfos,
        totalOdds: getTotalOdds(pairInfos),
        numberOfBets: getNumberOfBets(pairInfos),
        numberOfBetsFormatted: getFormattedNumberOfBets(
          pairInfos,
          state.ticketTypeID
        ),
        systemCombinations: systemInfoes
      });

      //pisi ga u local storage
      console.log("Saving items in local storage...");
      localStorage.setItem(
        LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS,
        JSON.stringify(updatedObject)
      );

      return updatedObject;
    case ActionTypes.TICKET_CHANGE_PAIR_CHECKED_STATE:
      pairInfos = [...state.ticketPairInfo];
      index = pairInfos.findIndex(x => x.matchID === action.matchID);
      if (index !== -1) {
        pairInfos[index].checked = action.checked;
      }

      //podesi im oznake
      pairInfos = processSystemLegends(pairInfos, state.ticketTypeID);
      systemInfoes = generateSystemCombinationsInfo(
        pairInfos,
        state.ticketTypeID
      );

      //updateaj systeminfo s pairinfos
      systemInfoes = updatePossibleWinPerCombination(pairInfos, systemInfoes);

      updatedObject = updateObject(state, {
        ticketPairInfo: pairInfos,
        totalOdds: getTotalOdds(pairInfos),
        numberOfBets: getNumberOfBets(pairInfos),
        numberOfBetsFormatted: getFormattedNumberOfBets(
          pairInfos,
          state.ticketTypeID
        ),
        systemCombinations: systemInfoes
      });

      //pisi ga u local storage
      console.log("Saving items in local storage...");
      localStorage.setItem(
        LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS,
        JSON.stringify(updatedObject)
      );

      return updatedObject;
    case ActionTypes.TICKET_SELECT_ALL_PAIRS:
      pairInfos = [...state.ticketPairInfo];

      for (let i = 0; i < pairInfos.length; i++) {
        pairInfos[i].checked = true;
      }

      //podesi im oznake
      pairInfos = processSystemLegends(pairInfos, state.ticketTypeID);
      systemInfoes = generateSystemCombinationsInfo(
        pairInfos,
        state.ticketTypeID
      );

      //updateaj systeminfo s pairinfos
      systemInfoes = updatePossibleWinPerCombination(pairInfos, systemInfoes);

      updatedObject = updateObject(state, {
        ticketPairInfo: pairInfos,
        totalOdds: getTotalOdds(pairInfos),
        numberOfBets: getNumberOfBets(pairInfos),
        numberOfBetsFormatted: getFormattedNumberOfBets(
          pairInfos,
          state.ticketTypeID
        ),
        systemCombinations: systemInfoes
      });

      //pisi ga u local storage
      console.log("Saving items in local storage...");
      localStorage.setItem(
        LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS,
        JSON.stringify(updatedObject)
      );

      return updatedObject;
    case ActionTypes.TICKET_DESELECT_ALL_PAIRS:
      pairInfos = [...state.ticketPairInfo];

      for (let i = 0; i < pairInfos.length; i++) {
        pairInfos[i].checked = false;
      }

      //podesi im oznake
      pairInfos = processSystemLegends(pairInfos, state.ticketTypeID);
      systemInfoes = generateSystemCombinationsInfo(
        pairInfos,
        state.ticketTypeID
      );

      //updateaj systeminfo s pairinfos
      systemInfoes = updatePossibleWinPerCombination(pairInfos, systemInfoes);

      updatedObject = updateObject(state, {
        ticketPairInfo: pairInfos,
        totalOdds: getTotalOdds(pairInfos),
        numberOfBets: getNumberOfBets(pairInfos),
        numberOfBetsFormatted: getFormattedNumberOfBets(
          pairInfos,
          state.ticketTypeID
        ),
        systemCombinations: systemInfoes
      });

      //pisi ga u local storage
      console.log("Saving items in local storage...");
      localStorage.setItem(
        LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS,
        JSON.stringify(updatedObject)
      );

      return updatedObject;
    case ActionTypes.TICKET_REMOVE_ALL_PAIRS:
      pairInfos = [];

      updatedObject = updateObject(state, {
        ticketPairInfo: pairInfos,
        totalOdds: 0,
        numberOfBets: 0,
        numberOfBetsFormatted: 0,
        systemCombinations: []
      });

      //pisi ga u local storage
      console.log("Saving items in local storage...");
      localStorage.setItem(
        LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS,
        JSON.stringify(updatedObject)
      );

      return updatedObject;
    case ActionTypes.TICKET_RESTORE_STATE_FROM_LOCALSTORAGE:
      return updateObject(state, action.ticketInfo);
    case ActionTypes.TICKET_PAIRS_UPDATE_COEFS:
      pairInfos = [...state.ticketPairInfo];
      // systemInfoes = generateSystemCombinationsInfo(
      //   pairInfos,
      //   state.ticketTypeID
      // );
      // console.log("PAIR INFOS ", pairInfos);
      // console.log("MATCHES ", action.updatedMatches);

      //za svaki par odi kroz listu
      for (let i = 0; i < pairInfos.length; i++) {
        const pi = pairInfos[i];

        //pronadji meč ako ima
        let match = action.updatedMatches.find(x => x.id === pi.matchID);

        if (match) {
          // console.log("UPDATED INFO FOR ", pi);
          // console.log("MATCH ", match);

          //nadi mu betinfo
          let betInfo = match.betInfo.find(x => x.id === pi.coefID);

          if (betInfo) {
            //podesi flag
            if (betInfo.value > pi.odds) {
              pi.direction = 1;
            } else if (betInfo.value < pi.odds) {
              pi.direction = -1;
            } else {
              pi.direction = 0;
            }

            //update!
            pi.odds = betInfo.value;

            pi.isEnabled = betInfo.isEnabled;

            if (!pi.isShown) {
              //zavrsilo, izbaci
              pairInfos.splice(i, 1);
            }

            pi.isShown = betInfo.isShown;
          }
        }
      }

      //dohvati stare sisteme
      systemInfoes = [...state.systemCombinations];

      //i update
      systemInfoes = updatePossibleWinPerCombination(pairInfos, systemInfoes);

      updatedObject = updateObject(state, {
        ticketPairInfo: pairInfos,
        systemCombinations: systemInfoes,
        totalOdds: getTotalOdds(pairInfos),
        numberOfBets: getNumberOfBets(pairInfos),
        numberOfBetsFormatted: getFormattedNumberOfBets(
          pairInfos,
          state.ticketTypeID
        )
        //systemCombinations: systemInfoes
      });

      //pisi ga u local storage
      //console.log("Saving items in local storage...");
      localStorage.setItem(
        LocalStorageKeys.LOCALSTORAGE_TICKET_ITEMS,
        JSON.stringify(updatedObject)
      );

      return updatedObject;

    case ActionTypes.TICKET_SET_EDITED_COMBINATION_ID:
      updatedObject = updateObject(state, {
        currentlyEditedCombinationID: action.combinationID
      });

      return updatedObject;

    case ActionTypes.TICKET_SET_BET_AMOUNT:
      updatedObject = updateObject(state, {
        betAmount: action.betAmount
      });

      return updatedObject;
    case ActionTypes.TICKET_SET_COMBINATION_BET_AMOUNT:
      //dohvati sisteme
      pairInfos = [...state.ticketPairInfo];
      systemInfoes = [...state.systemCombinations];

      //nadji sistem sa tim id-em
      let systemIdx = systemInfoes.findIndex(
        x => x.id === action.combinationID
      );

      if (systemIdx !== -1) {
        //dohvati ga
        let targetSystem = systemInfoes[systemIdx];

        console.log("SYSTEMS ARE HAHA ", targetSystem);
        console.log("SYSTEM IS HAHA ", targetSystem);

        //podesi sto trebas
        systemInfoes[systemIdx].betTotal = action.betAmount;
        systemInfoes[systemIdx].betPerCombination =
          action.betAmount / targetSystem.combinationsTotal;
      }

      //updateaj systeminfo s pairinfos
      systemInfoes = updatePossibleWinPerCombination(pairInfos, systemInfoes);

      updatedObject = updateObject(state, {
        systemCombinations: systemInfoes
      });

      return updatedObject;
    case ActionTypes.TICKET_SET_TICKET_TYPE:
      pairInfos = [...state.ticketPairInfo];
      //podesi im oznake
      pairInfos = processSystemLegends(pairInfos, action.ticketTypeID); //uzmi iz actiona jer postaje novi!
      systemInfoes = generateSystemCombinationsInfo(
        pairInfos,
        state.ticketTypeID
      );

      //updateaj systeminfo s pairinfos
      systemInfoes = updatePossibleWinPerCombination(pairInfos, systemInfoes);

      updatedObject = updateObject(state, {
        ticketTypeID: action.ticketTypeID,
        ticketPairInfo: pairInfos,
        systemCombinations: systemInfoes
      });

      return updatedObject;
    case ActionTypes.TICKET_TOGGLE_ACTIVE_SYSTEM:
      systemInfoes = [...state.systemCombinations];

      //pronadji ga
      var idx = systemInfoes.findIndex(x => x.id === action.systemID);

      if (idx >= 0) {
        //togglaj
        systemInfoes[idx].isChecked = !systemInfoes[idx].isChecked;

        updatedObject = updateObject(state, {
          systemCombinations: systemInfoes
        });
      }

      return updatedObject;
    default:
      return state;
  }
};

const getTotalOdds = pairs => {
  //izracunaj odds za svih;
  let odds = 0;

  //za svaki checkirani mnozi
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i];

    if (pair.checked && pair.isEnabled && pair.isShown) {
      //init odds
      if (odds === 0) {
        odds = 1;
      }

      odds *= pair.odds;
    }
  }
  return odds;
};

const getNumberOfBets = pairs => {
  //izracunaj odds za svih;
  let num = 0;

  //za svaki checkirani mnozi
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i];

    if (pair.checked && pair.isEnabled && pair.isShown) {
      //init odds
      num++;
    }
  }
  return num;
};

const getFormattedNumberOfBets = (pairs, ticketTypeID) => {
  var numOfBets = 0;
  var activeBets = pairs.filter(x => x.checked);

  //console.log("CHECKED BETS: ", activeBets);

  if (ticketTypeID === 2) {
    //combo
    numOfBets = activeBets.length;
    //console.log("COMBO: ", numOfBets);
  } else if (ticketTypeID === 3) {
    //system - izracunaj odvojeno fixane i nefixane
    var numFixed = activeBets.filter(x => x.isFix).length;

    if (numFixed === 0) {
      numOfBets = activeBets.length;
    } else {
      numOfBets = "F" + numFixed + "+" + (activeBets.length - numFixed);
    }

    //console.log("SYS: ", numOfBets);
  }

  //console.log("NUMBETS " + numOfBets);

  return numOfBets;
};

let systemLetters = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
];

const processSystemLegends = (pairs, ticketTypeID) => {
  let letterCounter = 0;

  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i];

    if (ticketTypeID === 3) {
      //system
      //if (pair.checked && pair.isEnabled && pair.isShown && !pair.isFix) {
      if (pair.checked && !pair.isFix) {
        //zasad nemoj micat ove koji su se deaktivirali, vidi s jakovom
        //init odds
        pairs[i].systemLegend = systemLetters[letterCounter];
        letterCounter++;
      } else {
        pairs[i].systemLegend = "";
      }
    } else {
      //combo, gazi
      pairs[i].systemLegend = "";
    }
  }

  console.log("PAIRS ARE ", pairs);

  return pairs;
};

const generateSystemCombinationsInfo = pairs => {
  var activeBets = pairs.filter(x => x.checked && !x.isFix);
  let betCount = activeBets.length;
  let combInfoes = [];
  let combLetters = [];

  //dohvati syslegende
  var betsWithLegends = activeBets.filter(x => x.systemLegend !== "");

  //console.log("BETS WITH LEGENDS ", betsWithLegends);
  for (let i = 0; i < betsWithLegends.length; i++) {
    const bet = betsWithLegends[i];
    combLetters.push(bet.systemLegend);
  }

  var combinations = getSystemCombinations(combLetters);

  console.log("COMBINATIONS: ", combinations);

  //console.log("NUMBER OF ACTIVE BETS: ", betCount);

  for (let i = 1; i < betCount; i++) {
    //filtriraj kombinacije
    var combs = combinations.filter(function(x) {
      return x.length === i;
    }); //donja granica

    //stvori objekte
    var comboList = [];

    for (let j = 0; j < combs.length; j++) {
      comboList.push({ combination: combs[j], possibleWin: 0 });
    }

    //stvori obj s infom
    let combInfo = {
      id: i,
      title: i + "/" + betCount,
      combinationsTotal: combs.length,
      lowerBound: i,
      upperBound: betCount,
      betTotal: 0,
      betPerCombination: 0,
      combinationList: comboList,
      isChecked: false
    };

    combInfoes.push(combInfo);
  }

  console.log("COMB INFOES ARE ", combInfoes);

  return combInfoes;
};

const updatePossibleWinPerCombination = (pairs, systems) => {
  //za svaki sistem
  for (let i = 0; i < systems.length; i++) {
    const system = systems[i];

    //prodji kroz svaku kombinaciju
    for (let j = 0; j < system.combinationList.length; j++) {
      const comb = system.combinationList[j];

      //pripremi si ctr
      let winCtr = 1;

      //imas slova
      //trazi pair za slovo po slovo
      for (let k = 0; k < comb.combination.length; k++) {
        const letter = comb.combination[k];
        //console.log("LETTER ", letter);

        //nadji par
        let pair = pairs.find(x => x.systemLegend === letter);

        if (pair) {
          winCtr *= pair.odds;
        }
      }

      //dodaj jos i sve fixane
      let fixedPairs = pairs.filter(x => x.isFix);

      for (let k = 0; k < fixedPairs.length; k++) {
        const pair = fixedPairs[k];
        winCtr *= pair.odds;
      }

      //i na kraju pomnozi s ulogom po comb
      winCtr *= system.betPerCombination;

      //i spremi
      system.combinationList[j].possibleWin = Math.round(winCtr);
    }
  }

  // console.log("PAIRS ARE ", pairs);
  // console.log("SYSTEMS ARE ", systems);

  return systems;
};

const getSystemCombinations = chars => {
  var result = [];
  var f = function(prefix, chars) {
    for (var i = 0; i < chars.length; i++) {
      result.push(prefix + chars[i]);
      f(prefix + chars[i], chars.slice(i + 1));
    }
  };
  f("", chars);
  return result;
};

export default reducer;



// WEBPACK FOOTER //
// ./src/ReduxStore/Reducers/TicketReducer.js